import React from 'react';
import { Skeleton } from '../primitives/Skeleton';

/**
 * Neutral KPI metric card — no decorative icon circles.
 * When `loading` is true, renders a shimmer skeleton instead of numeric placeholders.
 */
export default function KpiCard({
  eyebrow,
  value,
  unit,
  label,
  context,
  badge,
  loading = false,
  className = '',
  children,
}) {
  if (loading) {
    return (
      <div
        className={`app-kpi-card ${className}`.trim()}
        aria-busy="true"
        aria-label={label || 'Loading metric'}
      >
        <div className="app-kpi-card__top">
          <Skeleton width={72} height={10} radius={4} />
        </div>
        <div className="app-kpi-card__value app-numeric mt-4">
          <Skeleton width={96} height={28} radius={6} />
        </div>
        {label && (
          <div className="app-kpi-card__label-below mt-2">
            <Skeleton width={140} height={10} radius={4} />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`app-kpi-card ${className}`.trim()}>
      <div className="app-kpi-card__top">
        {eyebrow && <span className="app-kpi-card__eyebrow">{eyebrow}</span>}
        {badge && <div className="app-kpi-card__top-right">{badge}</div>}
      </div>
      <div className="app-kpi-card__value app-numeric">
        <span className="app-kpi-card__number">{value}</span>
        {unit && <span className="app-kpi-card__unit">{unit}</span>}
      </div>
      {label && <div className="app-kpi-card__label-below">{label}</div>}
      {context && <div className="app-kpi-card__context">{context}</div>}
      {children}
    </div>
  );
}

/**
 * Grid of KPI skeleton cards for initial async loads.
 */
export function KpiCardGridSkeleton({
  count = 4,
  className = 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6',
}) {
  return (
    <div className={className} aria-busy="true" aria-label="Loading metrics">
      {Array.from({ length: count }).map((_, i) => (
        <KpiCard key={i} loading label="Loading" />
      ))}
    </div>
  );
}
